// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"fc018a24","977":"ef55f94c"}[chunkId] + ".chunk.js";
};